module.exports = __webpack_public_path__ + "static/media/user-icon.38553ab1.svg";